import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import {
  Btn,
  BtnIcon,
  CustomCheckbox,
  CustomDataTableHeader,
  CustomModal,
  InputNumeroDecimal,
  InputNumeroInteiro,
  InputText,
  Loading,
} from '../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import { FaEdit } from 'react-icons/fa'
import { vinho } from '../../../../assets/js/colors'
import { showMessageBox } from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import {
  ajustarQuantidadeSobras,
  associarSobraOrdemColeta,
  getSobrasPendentes,
} from '../../../../services/api/https/ordem-coleta/ordem-coleta.http'
import {
  buildOrdemColetaQuantityInputState,
  getOrdemColetaInputLabels,
  getOrdemColetaQuantityConfig,
  getOrdemColetaQuantityValueFromInputs,
  renderOrdemColetaQuantityCell,
} from '../ordem-coleta-volume-and-units.helper'

function SobraPendente({
  tpId,
  companyId,
  ordemColetaId,
  dispatch,
  selectedIdentifier,
  pInicial,
  pFinal,
}) {
  // Vars

  // Hooks
  const [isLoading, setIsLoading] = useState(true)
  const [btnAssociarIsLoading, setBtnAssociarIsLoading] = useState(false)
  const [sobras, setSobras] = useState([])
  const [globalFilter, setGlobalFilter] = useState(selectedIdentifier)
  const [showModalSobra, setShowModalSobra] = useState(false)
  const [selectedSobra, setSelectedSobra] = useState(null)
  const [selecionarTodos, setSelecionarTodos] = useState(false)

  useEffect(() => {
    getSobras()
  }, [pInicial, pFinal])

  // Events
  const onItemClicked = (sobra, checked) => {
    const index = sobras.findIndex(s => s.leftover_product_id === sobra.leftover_product_id)
    if (index !== -1) {
      const nSobras = [...sobras]
      nSobras[index].selected = checked
      setSobras(nSobras)
    }
  }

  const onBtnAssociarClick = async () => {
    try {
      setBtnAssociarIsLoading(true)
      const sobrasSelecionadas = sobras.filter(s => s.selected)
      if (sobrasSelecionadas.length === 0) throw new Error('Selecione as Sobras para associação')
      const leftover_product_ids = sobrasSelecionadas.map(s => s.leftover_product_id)
      await associarSobraOrdemColeta(ordemColetaId, leftover_product_ids)
      await getSobras()
      dispatch(showMessageBox('Associação Realizada com Sucesso'))
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    } finally {
      setBtnAssociarIsLoading(false)
    }
  }

  const onSelectionarTodosClicked = () => {
    const _sobras = [...sobras]
    _sobras.forEach(s => (s.selected = !selecionarTodos))
    setSobras(_sobras)
    setSelecionarTodos(!selecionarTodos)
  }

  const onEditarSobraClick = sobra => {
    setSelectedSobra(sobra)
    setShowModalSobra(true)
  }

  const onModalSobraClose = () => {
    setShowModalSobra(false)
  }

  const onModalSobraSuccess = sobra => {
    const index = sobras.findIndex(s => s.leftover_product_id === sobra.id)
    if (index !== -1) {
      const nSobras = [...sobras]
      nSobras[index].qte_adjusted = sobra.qte_adjusted
      nSobras[index].qte_sobras =
        Math.round(
          (Number(nSobras[index].qte_original) + Number(nSobras[index].qte_adjusted || 0)) * 100,
        ) / 100
      nSobras[index].adjust_justification = sobra.adjust_justification
      setSobras(nSobras)
    }
    setShowModalSobra(false)
  }

  const onModalSobraError = error => {
    dispatch(showMessageBox(null, error))
    setShowModalSobra(false)
  }
  // Helpers
  const getSobras = async () => {
    try {
      setIsLoading(true)
      const fetchedSobras = await getSobrasPendentes(tpId, companyId, pInicial, pFinal)
      setSobras(fetchedSobras)
      setIsLoading(false)
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }

  // Render
  return isLoading ? (
    <div className="text-center">
      <Loading />
    </div>
  ) : (
    <div>
      <div style={{ marginBottom: 15, marginTop: 10 }}>
        <Btn isLoading={btnAssociarIsLoading} onClick={onBtnAssociarClick}>
          Associar
        </Btn>
        <div style={{ display: 'inline-block', marginLeft: 16 }}>
          <CustomCheckbox checked={selecionarTodos} onChange={onSelectionarTodosClicked}>
            Selecionar Todos
          </CustomCheckbox>
        </div>
      </div>
      <DataTable
        paginator={true}
        rows={5}
        value={sobras}
        header={<CustomDataTableHeader value={globalFilter} onChange={setGlobalFilter} />}
        globalFilter={globalFilter}
        emptyMessage="Não existe Sobra Pendente"
      >
        <Column
          header=""
          style={tableCellCentered(80)}
          body={sobra => (
            <CustomCheckbox
              checked={sobra.selected}
              onChange={value => onItemClicked(sobra, value)}
            />
          )}
        />
        <Column
          field="product_code"
          header="Código"
          style={{ textAlign: 'center', wordBreak: 'break-word', maxWidth: '150px' }}
        />
        <Column field="product_name" header="Produto" />
        <Column
          field="qte_original"
          header="Qte. Original"
          style={tableCellCentered(110)}
          body={sobra => renderOrdemColetaQuantityCell(sobra, sobra.qte_original)}
        />
        <Column
          field="qte_adjusted"
          header="Qte. Ajuste"
          style={tableCellCentered(110)}
          body={sobra => renderOrdemColetaQuantityCell(sobra, sobra.qte_adjusted || 0)}
        />
        <Column
          field="qte_sobras"
          header="Qte. Sobras"
          style={tableCellCentered(110)}
          body={sobra => renderOrdemColetaQuantityCell(sobra, sobra.qte_sobras)}
        />
        <Column field="picking" header="Picking" />
        <Column field="fleet_id" header="Rota" style={tableCellCentered()} />
        <Column field="driver_name" header="Motorista" />
        <Column
          header=""
          style={tableCellCentered(80)}
          body={sobra => (
            <BtnIcon onClick={() => onEditarSobraClick(sobra)}>
              <FaEdit color={vinho} size={18} />
            </BtnIcon>
          )}
        />
      </DataTable>
      {showModalSobra ? (
        <ModalAjusteSobra
          sobra={selectedSobra}
          onSuccess={onModalSobraSuccess}
          onError={onModalSobraError}
          onModalClose={onModalSobraClose}
        />
      ) : null}
    </div>
  )
}

function ModalAjusteSobra({ sobra, onSuccess, onModalClose, onError }) {
  // Vars
  const { qte_adjusted, adjust_justification, leftover_product_id } = sobra
  const initialQuantityState = buildOrdemColetaQuantityInputState(sobra, qte_adjusted)
  const { canUseFractionedInput } = getOrdemColetaQuantityConfig(sobra)
  const { volumeLabel, unitsLabel } = getOrdemColetaInputLabels(sobra)
  // Hooks
  const [qte, setQte] = useState(initialQuantityState.quantityValue)
  const [volumeValue, setVolumeValue] = useState(initialQuantityState.volumeValue)
  const [unitsValue, setUnitsValue] = useState(initialQuantityState.unitsValue)
  const [justification, setJustification] = useState(
    adjust_justification ? adjust_justification : '',
  )

  const onQuantityChange = (field, value) => {
    const nextVolumeValue = field === 'volume' ? value : volumeValue
    const nextUnitsValue = field === 'units' ? value : unitsValue

    setVolumeValue(nextVolumeValue)
    setUnitsValue(nextUnitsValue)
    setQte(getOrdemColetaQuantityValueFromInputs(sobra, nextVolumeValue, nextUnitsValue))
  }

  // Events
  const onBtnSalvarClicked = async () => {
    try {
      if (justification.trim().length <= 5) {
        onError('A justificativa deve conter pelo menos 5 caracteres')
        return
      }
      const qteAdjusted = Number(qte || 0)
      const fetchedSobra = await ajustarQuantidadeSobras(
        qteAdjusted,
        justification,
        leftover_product_id,
      )
      onSuccess(fetchedSobra)
    } catch (e) {
      onError(errorHandler(e))
    }
  }

  // Render
  return (
    <CustomModal header="Ajuste da Quantidade de Sobras" isVisible={true} onClose={onModalClose}>
      <form className="p-grid">
        <div className="p-col-3">
          {canUseFractionedInput ? (
            <InputNumeroInteiro
              label={`Qte Para Correção (${volumeLabel}) :`}
              marginTop={10}
              value={volumeValue}
              onChange={value => onQuantityChange('volume', value)}
            />
          ) : (
            <InputNumeroDecimal
              label={`Qte Para Correção (${volumeLabel}) :`}
              marginTop={10}
              value={volumeValue}
              onChange={value => onQuantityChange('volume', value)}
            />
          )}
        </div>
        <div className="p-col-3">
          <InputNumeroInteiro
            label={`${unitsLabel} :`}
            marginTop={10}
            value={unitsValue}
            onChange={value => onQuantityChange('units', value)}
            disabled={!canUseFractionedInput}
          />
        </div>
        <div className="p-col-6">
          <InputText
            label="Justificativa :"
            marginTop={10}
            value={justification}
            onChange={value => setJustification(value)}
          />
        </div>
        <div className="p-col-12">
          <Btn onClick={onBtnSalvarClicked}>Salvar</Btn>
        </div>
      </form>
    </CustomModal>
  )
}

const mapStateToProps = ({ ordem_coleta: { identifier } }) => ({ selectedIdentifier: identifier })
export default connect(mapStateToProps)(SobraPendente)
